import { createStyles, withStyles, type WithStyles } from "@material-ui/core";
import { CustomTable } from "features/shared/components";
import React from "react";
import arrayUtils from "shared/arrayUtils";
import type { CauseOfDeath } from "shared/types";
import type { CauseOfDeathFilterFormState } from "../causeOfDeath.types";
import { useCauseOfDeathTable } from "../hooks/useCauseOfDeathTable";
import { filterCauseOfDeathPredicate } from "../utils/causeOfDeath.utils";

type CauseOfDeathListTableProps = {
  causesOfDeath: CauseOfDeath[];
  filterForm: CauseOfDeathFilterFormState;
  isFormPanelOpen: boolean;
  onEditClick: (row: CauseOfDeath) => void;
  onToggleStatus: (row: CauseOfDeath, isCurrentDeleted: boolean) => void;
} & WithStyles<typeof styles>;

function CauseOfDeathListTable({
  causesOfDeath,
  filterForm,
  isFormPanelOpen,
  onEditClick,
  onToggleStatus,
}: CauseOfDeathListTableProps) {
  const { columns } = useCauseOfDeathTable({
    isFormPanelOpen,
    onEditClick,
    onToggleStatus,
  });

  const filteredRows = arrayUtils.filterItems({
    items: causesOfDeath,
    predicate: (item) => filterCauseOfDeathPredicate(item, filterForm),
  });

  return (
    <CustomTable
      columns={columns}
      getRowId={(row) => row.id.toString()}
      id="cause-of-death-list-table"
      rows={filteredRows}
    />
  );
}

const styles = () => createStyles({});

export default withStyles(styles)(CauseOfDeathListTable);
